<div class="table">
  <div class="table-height">
    <div class="table-box">
      <table>
        <thead>
          <tr>
            @for (propriete of proprietesAffichees(); track propriete; let i = $index) {
              <th width="{{table_width()[i] + '%' }}">
                <div class="table-header-item">
                  <span>{{ propriete.libelleAffiche | translate }}</span>
                </div>
              </th>
            }
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (d of tabDrilllogs(); track d; let i = $index) {
            <tr  [class.modifiable]="isModifiable() === i"  (click)="selectDrillLog(d,i, $event)" >
              <td  [title]="d.id" style="padding-left: 10px;">{{ d.id }}</td>
              <td  [title]="d.name">
                <input type="text"  [(ngModel)]="d.name" [disabled]="isModifiable() !== i"  [class.modifiable]="isModifiable() === i" name="name1"  #name1="ngModel" [ngClass]="{'error-value': name1.errors?.required  && showErrorModif()}" required  />
              </td>
              <td  [title]="d.shortName">
                <input type="text"  [(ngModel)]="d.shortName" [disabled]="isModifiable() !== i"    [class.modifiable]="isModifiable() === i" name="shortName1"  #shortName1="ngModel"  [ngClass]="{'error-value': shortName1.errors?.required  && showErrorModif()}" required  />
              </td>
              <td  [title]="d.color">
                <input type="text" style="margin-left: 1px; border-color:#D3D3D3" [cpPosition]="'left'"   [cpAlphaChannel]="'disabled'"  [class.modifiablePicker]="isModifiable() === i"    [style.background]="d.color" [value]="d.color" [(colorPicker)]="d.color" name="colorSelected"  [disabled]="isModifiable() !== i" [ngStyle]="{'cursor': isModifiable() === i ? 'pointer' : 'auto'}"  required />
              </td>
              <td><div class="icon">@if (isModifiable() === i) {
                <button  class="btn btn-primary"><i [title]="'GLOBAL.MODIFIER' | translate"  class="fas fa-save" (click)="update(d,i)"></i></button>
              }</div></td>
              <td><div class="icon">@if (isModifiable() === i) {
                <button class="btn btn-primary"><i  [title]="'GLOBAL.SUPPRIMER' | translate" class="fas fa-trash-alt" (click)="delete(d)"></i></button>
              }</div></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="footer" [class.focus]="isFooterFocus()" (focusout)="onFocusOutEvent()"  >
    <div class="edit-box">
      <div class="input-id"> <span styme="{margin-left:1rem;}"><b>{{ 'GLOBAL.AJOUTER'| translate }}</b></span> </div>
      <div class="input"><input type="text"  [(ngModel)]="newDrillLog().name"      (focus)="newDrillLogChange()"  name="name2"        #name2="ngModel"  [ngClass]="{'error-value': name2.errors?.required  && showErrorNew()}" required /></div>
      <div class="input"><input type="text"  [(ngModel)]="newDrillLog().shortName" (focus)="newDrillLogChange()"  name="shortName2"   #shortName2="ngModel"  [ngClass]="{'error-value': shortName2.errors?.required  && showErrorNew()}" required /></div>
      <div class="input">
        <input type="text" readonly  [value]="newDrillLog().color" [cpPosition]="'top-left'" (focus)="newDrillLogChange()" [cpAlphaChannel]="'disabled'"  [(colorPicker)]="newDrillLog().color" style="margin-left:0px;"  name="colorSelected"  [style.background]="newDrillLog().color"   required />
      </div>
      <div class="icon" style="width: 7%;"><button  class="btn btn-primary"><i class="fas fa-save" (click)="createDiscontinuity()"></i></button></div>
      <div class="icon" style="width: 7%;"><button  class="btn btn-primary"><i class="fas fa-eraser" (click)="clearNew()"></i></button></div>
    </div>
  </div>
</div>